import type {
  IOvieHealthIntentCount,
  IOvieHealthReasonCount,
} from './analytics-common';

export interface IOvieHealthAIPerformanceAnalytics {
  emergenciesDetected: number;
  availabilityIssues: number;
  intentBreakdown: IOvieHealthIntentCount[];
  transferReasons: IOvieHealthReasonCount[];
}
